// Số dòng nối thêm mỗi lần cuộn tới cuối bảng.
export const PAGE_SIZE_BOOKING = 30;

// Cách đáy bao nhiêu px thì đã tính là "cuộn tới cuối". Nối trước khi người
// dùng chạm đáy để không thấy khoảng trống.
const THRESHOLD_PX = 200;

// scroll: đọc từ .MuiDataGrid-virtualScroller (scrollTop/clientHeight/scrollHeight).
export function shouldLoadMore(
  scroll,
  visible_count,
  total,
  threshold = THRESHOLD_PX
) {
  if (scroll == null) return false;
  if (!(visible_count < total)) return false;

  const { scrollTop = 0, clientHeight = 0, scrollHeight = 0 } = scroll;

  // Khung chưa được layout (clientHeight 0): đo lúc này vô nghĩa, và nếu coi là
  // "chưa đầy" thì sẽ nối liên tục tới hết danh sách.
  if (clientHeight <= 0) return false;

  // Nội dung chưa cao hơn khung: chưa có scrollbar nào để cuộn, nhưng vẫn phải
  // nối thêm, nếu không bảng kẹt ở 30 dòng trên màn hình cao.
  if (scrollHeight <= clientHeight) return true;

  return scrollTop + clientHeight >= scrollHeight - threshold;
}

export function nextVisibleCount(
  visible_count,
  total,
  step = PAGE_SIZE_BOOKING
) {
  const next = visible_count + step;
  return next > total ? total : next;
}
